// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getPartOfSpeechById } from 'app/constants/enums/PartOfSpeech/main';

/* eslint-disable max-len */
export const ADJECTIVAL_NOUN = getPartOfSpeechById('Adjectival Noun');
export const ADJECTIVE = getPartOfSpeechById('Adjective');
export const ADVERB = getPartOfSpeechById('Adverb');
export const AUXILIARY_VERB = getPartOfSpeechById('Auxiliary Verb');
export const CONJUNCTION = getPartOfSpeechById('Conjunction');
export const DETERMINER = getPartOfSpeechById('Determiner');
export const INTERJECTION = getPartOfSpeechById('Interjection');
export const INTERROGATIVE = getPartOfSpeechById('Interrogative');
export const NOUN = getPartOfSpeechById('Noun');
export const NOUN_ABBREVIATION = getPartOfSpeechById('Noun Abbreviation');
export const PARTICLE = getPartOfSpeechById('Particle');
export const PHRASAL_VERB = getPartOfSpeechById('Phrasal Verb');
export const PHRASE = getPartOfSpeechById('Phrase');
export const PREPOSITION = getPartOfSpeechById('Preposition');
export const PRONOUN = getPartOfSpeechById('Pronoun');
export const PROPER_NOUN = getPartOfSpeechById('Proper Noun');
export const VERB = getPartOfSpeechById('Verb');
export const VERBAL_NOUN = getPartOfSpeechById('Verbal Noun');
/* eslint-enable max-len */
